import { useMemo } from 'react';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

interface ICloseJobSuccessPopupProps {
  onClose: () => void;
  hasHires?: boolean;
}

export const CloseJobSuccessPopup = ({ onClose, hasHires = false }: ICloseJobSuccessPopupProps) => {
  const title = useMemo(() => {
    return hasHires ? 'Congratulations on Your Hire(s)!' : 'Job Successfully Closed';
  }, [hasHires]);

  const description = useMemo(() => {
    return hasHires
      ? 'This job has been closed. Candidates who applied but weren’t selected have been automatically declined.'
      : 'This job is now permanently closed. All candidates who applied but weren’t selected have been automatically declined. Let us know how we can support your next hire.';
  }, [hasHires]);

  return (
    <ConfirmPopup
      Icon={AnimatedCheckCircle}
      title={title}
      description={description}
      rightButtonText="Done"
      rightButtonAction={onClose}
      closePopup={onClose}
      dismissiblePopup
      titleStyle={{ marginTop: 21 }}
      descriptionStyle={{ marginBottom: 30 }}
    />
  );
};
